import { CONTENT, IMAGE_ALT, reachGoal } from './leadMagnetContent';

// ----------------------------------------------------------------------------
// Лёгкий тизер лид-магнита для хиро-секции.
// Вторичная кнопка с миниатюрой обложки: по клику плавно прокручивает страницу
// к самому блоку пособия (там человек видит, что именно скачивает), а не
// открывает форму сразу.
// self-stretch — чтобы высота кнопки всегда совпадала с соседней акцентной
// кнопкой, независимо от того, как выровнен контейнер (items-center/start).
// ----------------------------------------------------------------------------
export default function LeadMagnetHeroTeaser() {
  const scrollToLeadMagnet = () => {
    reachGoal('leadmagnet_open');
    const el = document.getElementById('posobie');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <button
      type="button"
      onClick={scrollToLeadMagnet}
      className="group self-stretch inline-flex items-center justify-center gap-2.5 border border-white/30 bg-white/10 backdrop-blur-sm text-white pl-2 pr-4 py-1.5 rounded-lg text-sm sm:text-base font-semibold hover:bg-white/20 hover:border-white/50 transition-all whitespace-nowrap cursor-pointer"
    >
      <img
        src={CONTENT.compact.image.src}
        alt={IMAGE_ALT}
        width={CONTENT.compact.image.width}
        height={CONTENT.compact.image.height}
        className="w-9 h-9 sm:w-10 sm:h-10 rounded-md object-cover object-top flex-shrink-0"
      />
      <span>{CONTENT.teaser.button}</span>
      <i className="ri-arrow-down-line text-base opacity-80 group-hover:translate-y-0.5 transition-transform"></i>
    </button>
  );
}